var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3743 32.5463L16.4622 18.6342L2.55009 32.5463C1.97271 33.1512 1.01041 33.1512 0.433035 32.5463C-0.144345 31.969 -0.144345 31.0067 0.433035 30.4018L14.3451 16.4897L0.433035 2.57759C-0.144345 1.97271 -0.144345 1.03791 0.433035 0.433035C1.03791 -0.144345 1.97271 -0.144345 2.57759 0.433035L16.4897 14.3451L30.4018 0.433035C31.0067 -0.144345 31.9415 -0.144345 32.5463 0.433035C33.1512 1.01041 33.1512 1.97271 32.5463 2.57759L18.6342 16.4897L32.5463 30.4018C33.1237 30.9792 33.1237 31.9415 32.5463 32.5463C32.2714 32.8213 31.8865 32.9863 31.4741 32.9863C31.0617 32.9863 30.7042 32.8213 30.4018 32.5463H30.3743Z",
    fill: "#4A525D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.dda4c2e0c116229a042041b88f86e009.svg";
export { ForwardRef as ReactComponent };